import { Outlet, useParams } from "react-router-dom";

import { FullPageSpinner } from "@/components/Spinner";
import { GameId } from "@/gen/realtime";
import { useRealtimeGame } from "@/hooks/useRealtimeGame";
import { LiveChessboard } from "@/routes/game-feed/components/LiveChessboard";
import { useLanguageCodeWithDefault } from "@/utils/language";

import { Feed } from "./components/Feed";
import { LiveCommentaryForm } from "./components/LiveCommentaryForm";

const GameFeedRoute = () => {
    const { gameId } = useParams<{ gameId: string }>();
    const languageCode = useLanguageCodeWithDefault();

    const { game, plyData, gameReport, loading } = useRealtimeGame(gameId as GameId, languageCode)!;
    if (loading || !game || !plyData) {
        return <FullPageSpinner />;
    }

    return (
        <>
            <div className="h-[calc(100vh-100px)]">
                <div className="ml-4 grid h-full grid-cols-2 gap-4 overflow-hidden md:grid-rows-2 xl:grid-cols-3 xl:grid-rows-1">
                    <div className="col-span-1 row-span-2 xl:col-start-2 xl:row-start-1">
                        {game.result ? (
                            <span className="text-brand-white font-planar30 my-4 text-lg">
                                Game result: {game.result}
                            </span>
                        ) : null}
                        <LiveChessboard plyData={plyData} gameReport={gameReport} />
                    </div>
                    <div
                        className={`col-start-2 row-start-1 max-h-full overflow-y-auto xl:col-start-1 xl:row-start-1`}
                    >
                        <h1 className="text-brand-white my-4 text-xl font-bold">
                            {game.whitePlayer.nickname} - {game.blackPlayer.nickname}
                        </h1>
                        <LiveCommentaryForm game={game} />
                    </div>
                    <div
                        className={`col-start-2 row-span-2 row-start-2 overflow-y-auto overflow-x-hidden xl:col-start-3 xl:row-start-1`}
                    >
                        <Feed game={game} plyData={plyData} gameReport={gameReport} />
                    </div>
                </div>
            </div>
            <Outlet />
        </>
    );
};

export default GameFeedRoute;
